// import Tab from "bootstrap/js/dist/tab";  
import './PropertyMgmt.css';
import AIheader from "../../RentAI/AIheader";
import Footer from "../../../Component/Footer/Footer";
import ScrollingAnounce from "../../../Component/GetAroundpage/ScrollingAnounce/ScrollingAnounce";
import EasySetup from "../../../Component/GetAroundpage/EasySetup/EasySetup";
import BetaWaitlist from "../../../Component/Beta-Waitlist/BetaWaitlist";
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
// import CarRentalFaq from "../../../Component/Solutions/CarRentalFaq/CarRentalFaq";
import PopularBlog from '../../../Component/blog/PopularBlog/PopularBlog';

const PropertyMgmt = ()=> {

     
    const [isClient, setIsClient] = useState(false);
    const [showWaitlist, setShowWaitlist] = useState(false);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              const headerOffset = 80; // Adjust according to your header height
              const elementPosition = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: "smooth",
              });
            }
          }, 100); // Delay to ensure DOM is loaded
        }
      }, []);
      

    useEffect(() => {
      setIsClient(true);
    }, []);
  
    if (!isClient) return null;
   


    return (
        <>
        <AIheader/>
        <BetaWaitlist
        showJoinWaitList={showWaitlist}
        onClose={() => setShowWaitlist(false)}
        onOpen={() => setShowWaitlist(true)}
        />
            {/* START bannerCarRentalMain */}
            <section className="bannerCarRentalMain bannerMgmtMain">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                    <div className="col-lg-6">
                            <div className="bannerCarRentalLeft">
                                <small>PROPERTY MANAGEMENT</small>
                                <h1>Turn your<br/> properties into<br/> profit with built-<br/>in car rentals.</h1>
                                <p>Helping apartments, vacation rentals, and mixed-use buildings, generate more 
                                    revenue, improve guest experience with car rentals.</p>
                                <div className="carRentalBtn">
                                <button onClick={() => setShowWaitlist(true)} className="btn btnBlue">
                                    Join Waitlist
                                    </button>
                                    <a className="btn btnTransparent" href="/contact-sales">Contact Sales</a>
                                </div> 
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="bannerCarRentalRight">
                                <figure>
                                    <img className='img-fluid' src="/img/Solutions/mgmt_banner.png" alt="rent id"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerCarRentalMain */}


            {/* START whyCarRentalMain */}
            <section className="whyCarRentalMain whyMgmtMain">
                <div className="container">
                    <div className="whyCarRentalOuter">   
                        <div className='row align-items-center'>
                            <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='whyCarRentalLeft'>
                                    <small>PROPERTY MANAGERS</small>
                                    <h2>Why Property<br/> Managers <br/>Choose Rentid</h2>
                                </div>
                            </div>
                            <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='whyCarRentalRight'>
                                    <ul>
                                        <li>
                                            <h4>Convenience Based Rental Platform</h4>
                                            <p>Provide guests instant access with self-service booking 
                                            eliminating wait times and making every trip hassle-free.</p>
                                        </li>
                                        <li>
                                            <h4>Reduce Risk with Trust and Safety Tools</h4>
                                            <p>Renter ID verification, personal insurance validation, 
                                            risk scoring and built-in vehicle tracking keep rentals secure.</p>
                                        </li>
                                        <li>
                                            <h4>On-Rent Embedded Insurance & Protection</h4>
                                            <p>Tap into new revenue streams and save thousands with 
                                            daily-rate coverages for leisure and ride share rentals. </p>
                                        </li>
                                        <li>
                                            <h4>Handle Issues with Built-In Resolution Tools</h4>
                                            <p>Stay in control with a smart system for managing 
                                            renter disputes, violations, and claims — all in one place.</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END whyCarRentalMain */}

             {/* START gigDeliveryMain */}
             <section className='gigDeliveryMain gigMgmtMain'>
                <div className='container-fluid'>
                    <div className="row jusify-content-center align-items-center">
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryLeft"> 
                                <h2>A new stream of<br/> income, without <br/>new overhead.</h2>
                                <p>Rentid gives property managers the tools to offer on-site rental 
                                vehicles directly to residents or guests. Whether you manage 10 units 
                                or 1,000, you’ll unlock new value with every vehicle parked on-site. 
                                Our flexible platform supports single-car availability or entire 
                                fleets — no franchise fees, no marketplace middlemen.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryRight" >
                                <img className='img-fluid' src="/img/Solutions/ultimate_mgmt.webp" alt="rent id"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END gigDeliveryMain */}


            {/* STRAT tailoredHotelsMain */}
            <section className='tailoredHotelsMain tailoredMgmtMain'>
                <div className='container'>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="tailoredHotelsHead">
                                <h2>Built for Your Property, Wherever You Are</h2>
                                <p>Unlock new revenue, offer modern amenities, and give guests<br/> 
                                    or residents the freedom to drive — all from your own location.</p>
                            </div>
                        </div>
                    </div>             
                </div>


                {/* START tailoredHotelsOuter*/}
                <div className="tailoredHotelsOuter">
                    <div className='container'>
                        <div className="row justify-content-center align-items-center">

                            <div className="col-lg-6">
                                <div className="tailoredHotelsLeft">
                                    <figure>
                                        <img className='img-fluid' src="/img/Solutions/built_1.webp" alt="rent id"/>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tailoredHotelsRight">
                                    <h3>Upsell transportation <br/>right where it’s needed.</h3>
                                    <p>If your property is near an airport, stadium, or downtown 
                                        district, Rentid helps you offer instant, on-site car rentals 
                                        to guests and visitors. Instead of sending people to rideshares 
                                        or rental counters, give them direct access to vehicles — boosting 
                                        your revenue while elevating the guest experience.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* END tailoredHotelsOuter */}

                {/* START tailoredHotelsOuter*/}
                <div className="tailoredHotelsOuter tailoredHotelsOuter_2">
                    <div className='container'>
                        <div className="row justify-content-center align-items-center">

                            <div className="col-lg-6">
                                <div className="tailoredHotelsRight">
                                    <h3>Turn parking <br/>space into profit center. </h3>
                                    <p>With Rentid, you can activate on-site vehicles for both residential 
                                    tenants and commercial visitors. Whether it’s lunch-hour errands 
                                    or overnight getaways, your building becomes a go-to spot for 
                                    flexible transportation — increasing property value and convenience 
                                    in one move.</p>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="tailoredHotelsLeft">
                                    <figure>
                                        <img className='img-fluid' src="/img/Solutions/built_2.webp" alt="rent id"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* END tailoredHotelsOuter */}
 

                {/* START tailoredHotelsOuter*/}
                <div className="tailoredHotelsOuter">
                    <div className='container'>
                        <div className="row justify-content-center align-items-center">

                            <div className="col-lg-6">
                                <div className="tailoredHotelsLeft">
                                    <figure>
                                        <img className='img-fluid' src="/img/Solutions/built_3.webp" alt="rent id"/>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tailoredHotelsRight">
                                    <h3>A modern amenity <br/>residents actually use.</h3>
                                    <p>Offer residents access to shared or exclusive-use vehicles, booked through 
                                    your own branded link. It’s a high-impact amenity that supports urban 
                                    living without the costs of car ownership — and gives you a steady 
                                    stream of passive income.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* END tailoredHotelsOuter */}

                {/* START tailoredHotelsOuter*/}
                <div className="tailoredHotelsOuter tailoredHotelsOuter_2">
                    <div className='container'>
                        <div className="row justify-content-center align-items-center">

                            <div className="col-lg-6">
                                <div className="tailoredHotelsRight">
                                    <h3>Make every stay <br/>more memorable.</h3>
                                    <p>From coastal retreats to ski cabins, giving guests access to a 
                                    car on arrival transforms the experience. No waiting for 
                                    rideshares, no added stress — just freedom to explore. You 
                                    earn more per booking and deliver a next-level stay.</p>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="tailoredHotelsLeft">
                                    <figure>
                                        <img className='img-fluid' src="/img/Solutions/built_4.webp" alt="rent id"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* END tailoredHotelsOuter */}
            </section>
            {/* END tailoredHotelsMain */}

 
            {/* STRAT startWithMain */}
            <section className='startWithMain'>
                <div className='container'>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="startWithInner">
                                <h2>Start with one car. Scale when you're ready.</h2>
                                <p>You don’t need a full fleet to get started. Launch your first rental 
                                and grow at your pace. Rentid supports everything from side-income 
                                properties to nationwide portfolios.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END startWithMain */}


            {/* START choiceFormerMain */}
            <section  className="choiceFormerMain choiceDesktopMain blackChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>Single Platform for Car Rentals & Customer Satisfaction</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <ul className="nav nav-tabs main-tabs-ai">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#choiceFormer_1">
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent id"/>rent<span>direct</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_2">
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_3">
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent id"/>rent<span>shield</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_4">
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent id"/>rent<span>AI</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_5">
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent id"/>rent<span>success</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_6">
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent id"/>rent<span>academy</span>
                                    </a>
                                </li>
                            </ul>
                        
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className="tab-pane active" id="choiceFormer_1">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rentDirect"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Rental Management Platform</h3>
                                                    <p>RentDirect is a complete rental ecosystem for the modern world, integrating customizable workflows and tools tailored with your custom platform settings.</p>
                                                    <p>Practically driving itself with automations, dynamic data, and AI-powered intelligence, RentDirect delivers efficiency, flexibility, and scalable growth—unlike traditional rental software.</p>
                                                </div>        

                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 1 */}

                                {/* START Tab 2 */} 
                                <div className="tab-pane fade" id="choiceFormer_2">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Trust & Safety Workflows</h3>
                                                    <p>RentID gives hosts full control over who gets behind the wheel. With AI-driven screening, real-time ID verification, and personal insurance validation, only qualified renters gain access.</p>
                                                    <p>The DriverIQ™ Score assesses risk, while our National BlockList stops repeat offenders. Seamlessly integrated, these security workflows keep rentals safe without delaying bookings.</p>
                                                </div>                                            
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rent-id">Learn About RentID
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 2 */}

                                {/* START Tab 3 */}
                                <div className="tab-pane fade" id="choiceFormer_3">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>

                                                <div className='choiceFormerTop'>
                                                    <h3>Coverage & Protection Plans</h3>
                                                    <p>RentShield™ is built into every rental, giving you automatic protection without extra steps. Whether you need liability-only or full physical damage coverage, or roadside assistance, your fleet stays covered—without the need of manual intervention.</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 3 */}

                                {/* START Tab 4 */} 
                                <div className="tab-pane fade" id="choiceFormer_4">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Automated Rental Tasks </h3>
                                                    <p>Meet Rentii™ — your AI-powered back-office rental partner handling everything from renter support to booking management, and even your rental policy enforcement so you don’t have to.</p>
                                                    <p>Tap into the power of AI Rental Agent support for your rental business.</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 4 */}

                                {/* START Tab 5 */}
                                <div className="tab-pane fade" id="choiceFormer_5">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Rental Back Office Solutions</h3>
                                                    <p>Providing real-time support and structured policy management to help rental operators handle disputes, violations, and claims effortlessly.</p>
                                                    <p>Our expert-backed Resolution Center and rental back office ensure seamless fleet coordination, compliance, and renter management, so you can focus on growth.</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 5 */}


                                {/* START Tab 6 */} 
                                <div className="tab-pane fade" id="choiceFormer_6">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rentAcademy"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Learn, Teach, & Duplicate Hub</h3>
                                                    <p>Whether you’re launching your first rental or managing a growing fleet, RentAcademy™ provides expert-led courses, industry insights, and step-by-step guides to help you run a more profitable rental business.</p>
                                                    <p>We’re here every step of the way!</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 6 */}
                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceFormerMain */}

            {/* START choiceMobileMain */}
            <section  className="choiceFormerMain choiceMobileMain blackChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>Single Platform for Car Rentals & Customer Satisfaction</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="choiceAccordian">
                            <Accordion defaultActiveKey="0">
                                {/* start 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent id"/>rent<span>direct</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rentDirect"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'>
                                                <h3>Rental Management Platform</h3>
                                                <p>RentDirect is a complete rental ecosystem for the modern world, integrating 
                                                customizable workflows and tools tailored with your custom platform settings.</p>
                                                <p>Practically driving itself with automations, dynamic data, and AI-powered 
                                                intelligence, RentDirect delivers efficiency, flexibility, and scalable 
                                                growth—unlike traditional rental software.</p>
                                                <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rentId"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                    <h3>Trust & Safety Workflows</h3>
                                                    <p>RentID gives hosts full control over who gets behind the wheel. 
                                                    With AI-driven screening, real-time ID verification, and personal 
                                                    insurance validation, only qualified renters gain access. </p>
                                                    <p>The DriverIQ™ Score assesses risk, while our National BlockList 
                                                    stops repeat offenders. Seamlessly integrated, these security 
                                                    workflows keep rentals safe without delaying bookings.</p>
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rent-id">Learn About RentID
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 3 */}
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent id"/>rent<span>shield</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rentId"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                                                    <h3>Coverage & Protection Plans</h3>
                                                    <p>RentShield™ is built into every rental, giving you automatic protection 
                                                    without extra steps. Whether you need liability-only or full physical 
                                                    damage coverage, or roadside assistance, your fleet stays covered—without 
                                                    the need of manual intervention.</p>

                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 4 */}
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent id"/>rent<span>AI</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rentId"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                                                    <h3>Automated Rental Tasks </h3>
                                                    <p>Meet Rentii™ — your AI-powered back-office rental partner handling everything 
                                                    from renter support to booking management, and even your rental policy 
                                                    enforcement so you don’t have to.</p>
                                                    <p>Tap into the power of AI Rental Agent support for your rental business.</p>
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 5 */}
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent id"/>rent<span>success</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'> 
                                                <h3>Rental Back Office Solutions</h3>
                                                <p>Providing real-time support and structured policy management to help rental 
                                                 operators handle disputes, violations, and claims effortlessly.</p>
                                                <p>Our expert-backed Resolution Center and rental back office ensure seamless 
                                                fleet coordination, compliance, and renter management, so you can focus on growth.</p>
                                                <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 6 */}
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent id"/>rent<span>academy</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rentAcademy"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                        <h3>Learn, Teach, & Duplicate Hub</h3>
                                                        <p>Whether you’re launching your first rental or managing a growing fleet, RentAcademy™ provides expert-led courses, industry insights, and step-by-step guides to help you run a more profitable rental business.</p>
                                                        <p>We’re here every step of the way!</p>
                                
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                {/* end 6 */}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceMobileMain */}


            {/* START rentalbackOfficeMain */}
            <section className='rentalbackOfficeMain'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='rentalbackOfficeHead'>
                                <h6>OPERATIONAL SOLUTIONS</h6>
                                <h2>Rental Back Office</h2>
                                <p> Optimize operations with a fully integrated rental back-office solution that supports your 
                                team and simplifies management. Automated workflows resolve issues faster with a centralized 
                                system that handles the heavy lifting—so you can focus on growth.</p>
                            </div>
                        </div>
                    </div>



                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>AI Rental Agents</h3>
                                <p>AI rental super agent that handles tasks, solves problems, and keeps your business moving.</p>
                                 <a href="/rentai">Learn about AI Rental Agents</a> 
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Tolls & Tickets </h3>
                                <p>Automatically track, charge, and manage tolls and violations, ensuring accurate billing.</p>
                                 <a href="/rentsuccess#tolls_and_tickets">Learn about Tolls & Tickets </a> 
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Roadside Assistance </h3>
                                <p>24/7 roadside coverage, including towing, jump-starts, and lockout assistance.</p>
                                <a href="/rentshield#NationalRoadsideAssistance">Learn about Roadside Assistance </a>  
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Guest Communication</h3>
                                <p>Enhance customer experience with automated messages, real-time updates, and instant responses.</p>
                                 <a href="/rentsuccess#OnRentGuidelines">Learn about Guest Communication</a> 
                            </div>
                        </div>

                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Resource Center</h3>
                                <p>Centralized hub for renter education to streamline  operations & reduce inquiries.</p>
                                 <a href="/rentsuccess#BusinessEmpowerment">Learn about Resource Center</a>  
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Success Manager</h3>
                                <p>Dedicated support to increase utilization, revenue and grow with expert insights.</p>
                                <a href="/rentsuccess#businessEmpowerment_2">Learn about Success Manager</a>  
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Technical Support</h3>
                                <p>Ensure smooth operations with expert assistance, system integrations and troubleshooting.</p>
                                 <a href="/rentsuccess#TechnicalSupport">Learn about Technical Support</a> 
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Digital Marketing</h3>
                                <p>Attract more renters with targeted campaigns, automated re-marketing, and insights.</p>
                                <a href="/rentsuccess#businessEmpowerment_3">Learn about Digital Marketing</a> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END rentalbackOfficeMain */}

            {/* START industryTrustMain */}
            <section className="industryTrustMain">
                <div className="container">
                    <div className='industryTrustOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustLeft'>
                                    <h2>Industry trust<span> and transparency</span> </h2>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustRight'>
                                    <ul>
                                        <li>
                                            <img className="img-fluid" width="140px" src="/img/AnoucementPage/industryTrust_1.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="164px" src="/img/AnoucementPage/industryTrust_2.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="146px" src="/img/AnoucementPage/industryTrust_3.png" alt="Industry trust and transparency" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryTrustMain */}
            
            {/* START resolutionAnounceMain */}
            <section className='resolutionAnounceMain'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='resolutionAnounceHead'>
                                <h6>ADMINISTRATIVE SUPPORT</h6>
                                <h2>Rentid Resolution Center</h2>
                                <p>Managing rental disputes is costly and time-consuming. Rentid’s Resolution Center streamlines incident submission, tracking, and resolution for violations, damages, and claims—all in one platform—with automated invoicing and payment recovery.</p>
                            </div>
                        </div>
                    </div>

                    <div className='row align-items-center'>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className="resolutionAnounceLeft">
                                <div className='row align-items-center'>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>On Rent Guest Violations</h3>
                                            <p>Submit incidents for infractions of the rental agreement, including late returns, 
                                            mileage overages, and vehicle misuse.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>Submit Insurance Claims</h3>
                                            <p>Process and track insurance claims directly within the platform, 
                                            reducing paperwork and speeding up resolutions.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>Issue Guest Refunds</h3>
                                            <p>Control refunds seamlessly, whether issuing full or partial reimbursements, 
                                            handling approvals, or tracking disputes.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>Report Guest Behavior</h3>
                                            <p>Report guest behavior to improve risk assessment, prevent future issues, and maintain high rental standards.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="resolutionAnounceBottom">
                                     <a className="btn btnTransparent_5" href="/rentsuccess#ResolutionCenter">Explore The Resolution Center 
                                     <img src="/img/AnoucementPage/arrow-right.svg" alt="icon"/></a>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className="resolutionAnounceRight">
                                <figure>
                                    <img className='img-fluid' src="/img/AnoucementPage/resolutionAnounceRight.png" alt="rent id"/>
                                </figure>
                            </div>

                        </div>
                    
                    </div>

                </div>
            </section>
            {/* END resolutionAnounceMain */}


            {/* START trackingTelematicsMain */}
            <section className="trackingTelematicsMain">
                <div className="container">
                    <div className='row align-items-center'>

                        <div className='col-lg-6 col-md-12 col-sm-12'>
                            <div className='trackingTelematicsLeft'>
                                <ul>
                                    <li>
                                        <img className="img-fluid" width="105px" src="/img/AnoucementPage/trackingTelematics_1.png" alt="Industry trust and transparency" />
                                    </li>
                                    <li>
                                        <img className="img-fluid" width="121px" src="/img/AnoucementPage/trackingTelematics_2.png" alt="Industry trust and transparency" />
                                    </li>
                                    <li>
                                        <img className="img-fluid" width="123px" src="/img/AnoucementPage/trackingTelematics_3.png" alt="Industry trust and transparency" />
                                    </li>
                                    <li>
                                        <img className="img-fluid" width="123px" src="/img/AnoucementPage/trackingTelematics_4.png" alt="Industry trust and transparency" />
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className='col-lg-6 col-md-12 col-sm-12'>
                            <div className='trackingTelematicsRight'>
                                <h6>INTEGRATIONS</h6>
                                <h2>Tracking and Telematics</h2>
                                <p>Rentid’s built-in telematics provides real-time tracking, driver behavior insights, and remote security controls—without needing third-party systems. Protect your fleet, reduce risk, and optimize vehicle performance, all from one platform.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* END trackingTelematicsMain */}
            <EasySetup/>

            {/* <CarRentalFaq/> */}

            <ScrollingAnounce/>
         
            <PopularBlog/>

            <Footer/>
        </>
    )
}

export default PropertyMgmt;